module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Save-54111e866c6a5aa593a93c8a8b983448.svg";